import { sleep } from "./util/sleep";
import { ResourceKey } from "i18next";

export class Route {
    public slug: string;
    public index: number;
    public langKey: ResourceKey;
    public testId: string | undefined;

    constructor(slug: string, index: number, title: ResourceKey, testId?: string) {
        this.slug = slug;
        this.index = index;
        this.langKey = title;
        this.testId = testId;
    }
}

export const ROUTE_PATH_ADAPT = '/adapt';
export const ROUTE_PATH_CONTOUR = '/contour';
export const ROUTE_PATH_DOSE = '/dose';
export const ROUTE_PATH_IMAGE = '/image';

/** index for routes that should not be shown in the navigation panel */
const HIDDEN_NAV_INDEX = -1;

const routes = {
    homePage: new Route('/', 0, 'sideNav.home'),
    contourCustomizationPage: new Route(ROUTE_PATH_CONTOUR + '/customization', 1, 'sideNav.contour.modelCustomization', 'customization-nav-contour'),
    contourAllStructuresPage: new Route(ROUTE_PATH_CONTOUR + '/all-structures', 2, 'sideNav.contour.allStructures', 'customization-nav-contour-all-structures'),
    contourModelSelectionPage: new Route(ROUTE_PATH_CONTOUR + '/selection', 3, 'sideNav.contour.modelSelection', 'customization-nav-contour-model-selection'),
    doseCustomizationPage: new Route(ROUTE_PATH_DOSE + '/customization', 5, 'sideNav.dose.modelCustomization', 'customization-nav-dose'),
    // doseModelSelectionPage: new Route(ROUTE_PATH_DOSE + '/selection', 6, 'sideNav.dose.modelSelection'),
    adaptCustomizationPage: new Route(ROUTE_PATH_ADAPT + '/customization', 10, 'sideNav.adapt.modelCustomization', 'customization-nav-adapt'),
    imageCustomizationPage: new Route(ROUTE_PATH_IMAGE + '/customization', 15, 'sideNav.image.modelCustomization', 'customization-nav-image'),
    connectorConfigPage: new Route('/connector', 20, 'sideNav.daemonConfig'),
    textEditorPage: new Route('/text-editor', 25, 'sideNav.fileEditor'),
    licensePage: new Route('/license', 30, 'sideNav.license'),
    configurationTargetSettingsPage: new Route('/settings', 35, 'sideNav.configurationTargetSettings'),

    // the routes below this line are not meant to be used in the navigation panel
    aboutPage: new Route('/about', HIDDEN_NAV_INDEX, 'sideNav.about'),
    loginPage: new Route('/login', HIDDEN_NAV_INDEX, ''),
    cloudConfigPage: new Route('/cloud', HIDDEN_NAV_INDEX, ''),

    // retain old daemon url for backwards compatibility
    daemonConfigPage: new Route('/daemon', HIDDEN_NAV_INDEX, 'sideNav.daemonConfig'),

};

export default routes;

/** Perform a redirect to a (valid) route slug. */
const doRedirect = async (redirectToSlug: string, onlyChangeUrl?: boolean) => {
    // for security reasons ONLY allow redirect to valid route slugs
    const redirectPortions = redirectToSlug.split('#');
    const redirectToRoute = redirectPortions[redirectPortions.length - 1];
    const segments = redirectToRoute.split('?');
    const matchingRoute = Object.values(routes).find(r => r.slug === segments[0]);
    if (matchingRoute) {
        const newUrl = `${window.location.origin}${redirectToSlug}`;

        if (!onlyChangeUrl) {
            console.log(`Navigating to ${newUrl}`);
            window.location.replace(newUrl);
        }
        else {
            // change the URL without reloading the page
            window.history.pushState({}, '', newUrl);
        }

        // prevent the rest of the code from running while we're redirecting,
        // this way we don't start useless API requests that'll just get cancelled
        // (and would throw harmless errors into console)
        await sleep(1000);
    }
}

export { doRedirect };
